"use strict";
(self["__LOADABLE_LOADED_CHUNKS__"] = self["__LOADABLE_LOADED_CHUNKS__"] || []).push([[207,6321],{

/***/ 36609:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* unused harmony export keyToIconNameMap */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(78364);
/* harmony import */ var components_dataDisplay__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(90234);




const keyToIconNameMap = {
    "BESTSELLER": "48/bestseller",
    "CHARITY": "48/charity",
    "CLEAN": "48/clean",
    "LIMITED_EDITION": "48/limited-time",
    "NEW_ARRIVAL": "48/new",
    "SOLD_OUT": "48/out-of-stock"
};
const ProductGraphicLabels = (props)=>{
    let { className, items, limit } = props;
    if (!(items === null || items === void 0 ? void 0 : items.length)) {
        return null;
    }
    if (limit && items.length > limit) {
        items = items.slice(0, limit);
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (0,classnames__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(className, "grid grid-cols-1 gap-16"),
        children: items.map((key)=>Boolean(keyToIconNameMap[key]) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_dataDisplay__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
                className: "mx-auto",
                name: keyToIconNameMap[key],
                "aria-label": key
            }, key))
    });
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.memo(ProductGraphicLabels));


/***/ }),

/***/ 28329:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ ProductPrice_ProductPrice)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ../../node_modules/.pnpm/clsx@2.1.0/node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(78364);
// EXTERNAL MODULE: ./local_modules/intl/useIntl.ts
var useIntl = __webpack_require__(2129);
// EXTERNAL MODULE: ./src/helpers/modifiers/formatPrice.ts
var formatPrice = __webpack_require__(23450);
// EXTERNAL MODULE: ./src/components/dataDisplay/Text/Text.tsx + 1 modules
var Text = __webpack_require__(78565);
;// CONCATENATED MODULE: ./src/compositions/ProductPrice/messages.ts
/* harmony default export */ const messages = ({
    old: {
        en: "Price reduced from"
    },
    new: {
        en: "On sale at"
    }
});

;// CONCATENATED MODULE: ./src/compositions/ProductPrice/ProductPrice.tsx







// TODO should we use currencyCode from data? - added on 14.01.2022 by sonatskiy
const ProductPrice = (props)=>{
    var _data_discountPrice, _data_standardPrice;
    const { className, data, formattedData, textStyle = "h8", oldPriceClassName = "font-normal", newPriceClassName = "font-bold", withNbsp = true } = props;
    const intl = (0,useIntl/* default */.Z)();
    const discountPrice = data === null || data === void 0 ? void 0 : (_data_discountPrice = data.discountPrice) === null || _data_discountPrice === void 0 ? void 0 : _data_discountPrice.amount;
    const standardPrice = data === null || data === void 0 ? void 0 : (_data_standardPrice = data.standardPrice) === null || _data_standardPrice === void 0 ? void 0 : _data_standardPrice.amount;
    let finalPrice;
    let oldPrice;
    let oldPriceLabel;
    let newPriceLabel;
    if (formattedData) {
        const { discountPrice, standardPrice } = formattedData;
        finalPrice = discountPrice || standardPrice;
        if (finalPrice !== standardPrice) {
            oldPrice = standardPrice;
            oldPriceLabel = intl.formatMessage(messages.old);
            newPriceLabel = intl.formatMessage(messages.new);
        }
    } else {
        if (typeof discountPrice === "number") {
            // it's formatted as USD, not cents
            finalPrice = (0,formatPrice/* default */.Z)(discountPrice, {
                isCents: false
            });
            if (standardPrice > discountPrice) {
                oldPrice = (0,formatPrice/* default */.Z)(standardPrice, {
                    isCents: false
                });
                oldPriceLabel = intl.formatMessage(messages.old);
                newPriceLabel = intl.formatMessage(messages.new);
            }
        } else if (typeof standardPrice === "number") {
            finalPrice = (0,formatPrice/* default */.Z)(standardPrice, {
                isCents: false
            });
        }
    }
    if (!finalPrice) {
        return null;
    }
    if (oldPrice) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.ZP, {
            className: className,
            style: textStyle,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("s", {
                    className: (0,clsx/* default */.Z)(oldPriceClassName),
                    "aria-label": oldPriceLabel,
                    "data-testid": "oldPrice",
                    children: oldPrice
                }),
                withNbsp && "\xa0",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                    className: (0,clsx/* default */.Z)(newPriceClassName),
                    "aria-label": newPriceLabel,
                    "data-testid": "price",
                    children: finalPrice
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
        className: (0,clsx/* default */.Z)(className, newPriceClassName),
        style: textStyle,
        "data-testid": "price",
        children: finalPrice
    });
};
/* harmony default export */ const ProductPrice_ProductPrice = (/*#__PURE__*/react.memo(ProductPrice));


/***/ }),

/***/ 25600:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ CartModal_CartModal)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ../../node_modules/.pnpm/clsx@2.1.0/node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(78364);
// EXTERNAL MODULE: ./local_modules/analytics/index.ts
var analytics = __webpack_require__(95812);
// EXTERNAL MODULE: ./local_modules/device/useDevice.ts
var useDevice = __webpack_require__(96934);
// EXTERNAL MODULE: ./local_modules/links/index.ts + 4 modules
var links = __webpack_require__(94957);
// EXTERNAL MODULE: ./src/hooks/useFt.ts
var useFt = __webpack_require__(64667);
// EXTERNAL MODULE: ./src/hooks/useAb.ts
var useAb = __webpack_require__(80550);
// EXTERNAL MODULE: ./src/helpers/constants/index.ts + 8 modules
var constants = __webpack_require__(63687);
// EXTERNAL MODULE: ./src/helpers/modifiers/formatPrice.ts
var formatPrice = __webpack_require__(23450);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@growthbook+growthbook-react@0.23.0_react@18.2.0/node_modules/@growthbook/growthbook-react/dist/esm/index.js + 5 modules
var esm = __webpack_require__(26853);
// EXTERNAL MODULE: ./src/modules/cart/index.ts + 4 modules
var modules_cart = __webpack_require__(13909);
// EXTERNAL MODULE: ./src/components/layout/Bone/Bone.tsx + 1 modules
var Bone = __webpack_require__(29564);
// EXTERNAL MODULE: ./src/components/feedback/ModalHeadline/ModalHeadline.tsx
var ModalHeadline = __webpack_require__(52690);
// EXTERNAL MODULE: ./src/components/feedback/ModalButtons/ModalButtons.tsx
var ModalButtons = __webpack_require__(99032);
// EXTERNAL MODULE: ./src/components/feedback/ModalWithLayers/ModalWithLayers.tsx + 4 modules
var ModalWithLayers = __webpack_require__(14546);
// EXTERNAL MODULE: ./src/components/inputs/Button/messages.ts
var messages = __webpack_require__(34212);
// EXTERNAL MODULE: ./src/compositions/modals/FirstProductModal/FirstProductModal.tsx + 1 modules
var FirstProductModal = __webpack_require__(28914);
// EXTERNAL MODULE: ./src/compositions/orderItems/util/useOrderBill.ts + 1 modules
var useOrderBill = __webpack_require__(55971);
// EXTERNAL MODULE: ./src/compositions/orderItems/OrderBillItem/OrderBillItem.tsx
var OrderBillItem = __webpack_require__(17237);
// EXTERNAL MODULE: ./src/compositions/orderItems/SubscriptionOrderItem/SubscriptionOrderItem.tsx + 4 modules
var SubscriptionOrderItem = __webpack_require__(83897);
// EXTERNAL MODULE: ./src/compositions/orderItems/GiftSubscriptionOrderItem/GiftSubscriptionOrderItem.tsx + 1 modules
var GiftSubscriptionOrderItem = __webpack_require__(89379);
// EXTERNAL MODULE: ./src/compositions/orderItems/GiftCardOrderItem/GiftCardOrderItem.tsx + 1 modules
var GiftCardOrderItem = __webpack_require__(29572);
// EXTERNAL MODULE: ./src/compositions/orderItems/GiftSubscriptionOfferOrderItem/GiftSubscriptionOfferOrderItem.tsx
var GiftSubscriptionOfferOrderItem = __webpack_require__(65292);
// EXTERNAL MODULE: ./src/compositions/orderItems/index.tsx
var orderItems = __webpack_require__(44098);
// EXTERNAL MODULE: ./src/compositions/orderItems/ProductOrderItem/ProductOrderItem.tsx + 6 modules
var ProductOrderItem = __webpack_require__(73169);
// EXTERNAL MODULE: ./local_modules/analytics/context/index.ts
var context = __webpack_require__(13210);
// EXTERNAL MODULE: ./src/helpers/errors/index.ts
var errors = __webpack_require__(83305);
// EXTERNAL MODULE: ./src/modules/subscription/subscribe/index.tsx
var subscribe = __webpack_require__(70104);
// EXTERNAL MODULE: ./src/components/dataDisplay/Text/Text.tsx + 1 modules
var Text = __webpack_require__(78565);
// EXTERNAL MODULE: ./src/components/inputs/Button/Button.tsx + 6 modules
var Button = __webpack_require__(30468);
// EXTERNAL MODULE: ./src/compositions/ProductPrice/ProductPrice.tsx + 1 modules
var ProductPrice = __webpack_require__(28329);
// EXTERNAL MODULE: ./src/compositions/orderItems/OrderItemBase/OrderItemBase.tsx
var OrderItemBase = __webpack_require__(1497);
// EXTERNAL MODULE: ./src/compositions/orderItems/OrderProductBase/OrderProductBase.tsx + 2 modules
var OrderProductBase = __webpack_require__(83221);
;// CONCATENATED MODULE: ./src/compositions/orderItems/SubscriptionBanner/messages.ts
/* harmony default export */ const SubscriptionBanner_messages = ({
    title: {
        en: "Would you like to add a monthly fragrance subscription?"
    },
    course: {
        title: {
            en: `
        <span class="text-gold-50">Save on this course</span> with a <br /> Scentbird subscription.
      `
        }
    },
    text: {
        en: `
      A month-to-month subscription to Scentbird. Billed monthly,
      renews automatically.
    `
    },
    emptyProduct: {
        en: `
      Your choice of one 8ml fragrance a month, with a free case included
    `
    },
    no: {
        en: "No thanks"
    },
    yes: {
        en: "Yes, add it!"
    }
});

;// CONCATENATED MODULE: ./src/compositions/orderItems/SubscriptionBanner/SubscriptionBanner.tsx













const SubscriptionBanner = (props)=>{
    const { className, onCancel, hasAcademyCourse } = props;
    const { formattedPrice, formattedPriceWithDiscount, offerType, couponCode, eventDiscountText, handleSubscribeClick } = (0,subscribe/* useSubscribeOffer */.Hu)();
    const [submit, { isFetching: isSubmitting }] = (0,modules_cart/* useCartModify */.sd)();
    const isSubCartOfferEnabled = offerType === "discount";
    const trackParams = isSubCartOfferEnabled ? {
        discount: eventDiscountText,
        coupon: couponCode
    } : {};
    const handleConfirmClick = async ()=>{
        if (isSubCartOfferEnabled) {
            // apply coupon
            handleSubscribeClick();
        }
        // for the academy we want to keep user in the cart to show the discount
        if (hasAcademyCourse) {
            (0,analytics/* track */.j)("Banner click", {
                placement: "Cart",
                content: "Subscribe",
                action: "Add to cart",
                ...trackParams
            });
            try {
                const { page, pageType } = (0,context/* getAnalyticsContext */.cV)();
                await submit({
                    subscriptionItem: {
                        plan: "MONTHLY"
                    },
                    metadata: {
                        page,
                        pageType
                    }
                });
            } catch (error) {
                (0,errors/* processError */.wY)(error);
            }
        } else {
            (0,analytics/* track */.j)("Banner click", {
                placement: "Cart",
                content: "Subscribe",
                action: "link",
                link: links/* default */.ZP.subscribe,
                ...trackParams
            });
        }
    };
    const priceNode = isSubCartOfferEnabled && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductPrice/* default */.Z, {
        className: "flex flex-col items-end",
        textStyle: "p2",
        withNbsp: false,
        formattedData: {
            discountPrice: formattedPriceWithDiscount,
            standardPrice: formattedPrice
        }
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: className,
        "data-testid": "subscriptionBanner",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                style: "h7",
                message: hasAcademyCourse ? SubscriptionBanner_messages.course.title : SubscriptionBanner_messages.title,
                html: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(OrderItemBase/* default */.Z, {
                className: "mt-16",
                "data-testid": "subscriptionBannerItem",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                        style: "p2",
                        message: SubscriptionBanner_messages.text,
                        html: true
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderProductBase/* default */.Z, {
                        className: "mt-24",
                        price: isSubCartOfferEnabled ? undefined : formattedPrice,
                        priceNode: priceNode,
                        "data-testid": "subscriptionCase",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                            style: "p2",
                            message: SubscriptionBanner_messages.emptyProduct
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "mt-40 flex justify-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                size: 38,
                                style: "secondary",
                                title: SubscriptionBanner_messages.no,
                                disabled: isSubmitting,
                                onClick: onCancel,
                                "data-testid": "cancelButton"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                className: "ml-12",
                                size: 38,
                                style: "primary",
                                title: SubscriptionBanner_messages.yes,
                                to: hasAcademyCourse ? undefined : links/* default */.ZP.subscribe,
                                loading: isSubmitting,
                                onClick: handleConfirmClick,
                                "data-testid": "confirmButton"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ const SubscriptionBanner_SubscriptionBanner = (/*#__PURE__*/react.memo(SubscriptionBanner));

;// CONCATENATED MODULE: ./src/compositions/orderItems/GiftSubscriptionBanner/messages.ts
/* harmony default export */ const GiftSubscriptionBanner_messages = ({
    title: {
        en: "Would you like to add a Scentbird subscription for yourself?"
    },
    no: {
        en: "No thanks"
    },
    yes: {
        en: "Yes, add it!"
    }
});

;// CONCATENATED MODULE: ./src/compositions/orderItems/GiftSubscriptionBanner/GiftSubscriptionBanner.tsx










const GiftSubscriptionBanner = (props)=>{
    const { className, data, onCancel } = props;
    const { description, image, priceOfferText, whatYouAreGetting } = data;
    const { couponCode, eventDiscountText, handleSubscribeClick, offerType } = (0,subscribe/* useSubscribeOffer */.Hu)();
    const isSubCartOfferEnabled = offerType === "discount";
    const trackParams = isSubCartOfferEnabled ? {
        discount: eventDiscountText,
        coupon: couponCode
    } : {};
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: className,
        "data-testid": "giftSubscriptionOfferBanner",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                style: "h7",
                message: GiftSubscriptionBanner_messages.title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(OrderItemBase/* default */.Z, {
                className: "mt-16",
                "data-testid": "giftSubscriptionOfferBannerItem",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                        style: "p2",
                        message: whatYouAreGetting
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderProductBase/* default */.Z, {
                        className: "mt-24",
                        image: image,
                        rebrandImage: image,
                        priceNode: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                            message: priceOfferText,
                            style: "t2"
                        }),
                        "data-testid": "giftSubscriptionOfferCase",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                            style: "p2",
                            message: description
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "mt-40 flex justify-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                size: 38,
                                style: "secondary",
                                title: GiftSubscriptionBanner_messages.no,
                                onClick: onCancel,
                                "data-testid": "cancelButton"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                className: "ml-12",
                                size: 38,
                                style: "primary",
                                title: GiftSubscriptionBanner_messages.yes,
                                to: links/* default */.ZP.subscribe,
                                onClick: ()=>{
                                    (0,analytics/* track */.j)("Banner click", {
                                        placement: "Cart",
                                        content: "Subscribe",
                                        action: "link",
                                        link: links/* default */.ZP.subscribe,
                                        ...trackParams
                                    });
                                    if (isSubCartOfferEnabled) {
                                        // apply coupon
                                        handleSubscribeClick();
                                    }
                                },
                                "data-testid": "confirmButton"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ const GiftSubscriptionBanner_GiftSubscriptionBanner = (/*#__PURE__*/react.memo(GiftSubscriptionBanner));

// EXTERNAL MODULE: ./local_modules/local-storage/index.ts + 2 modules
var local_storage = __webpack_require__(71106);
// EXTERNAL MODULE: ./local_modules/date/difference.ts
var difference = __webpack_require__(44541);
// EXTERNAL MODULE: ./src/modules/subscription/subscription/index.tsx + 1 modules
var subscription_subscription = __webpack_require__(36888);
// EXTERNAL MODULE: ./src/modules/user/shownPopups/index.tsx + 2 modules
var user_shownPopups = __webpack_require__(59247);
// EXTERNAL MODULE: ./src/modules/user/user/index.tsx + 1 modules
var user = __webpack_require__(40038);
// EXTERNAL MODULE: ./src/compositions/orderItems/util/useOrderItems.ts
var useOrderItems = __webpack_require__(7679);
;// CONCATENATED MODULE: ./src/compositions/modals/CartModal/components/CartItems/util/useCartItems.ts








const useCartItems = (cart)=>{
    const orderItems = (0,useOrderItems/* default */.Z)(cart);
    const isGiftSubscriptionOfferEnabled = (0,useFt/* default */.Z)(constants/* default */.Z.features.giftSubscriptionOffer);
    const { subscription } = (0,subscription_subscription/* useSubscription */.mU)();
    const { shownPopups } = (0,user_shownPopups/* useShownPopups */.BP)();
    const { isLoggedIn } = (0,user/* useUser */.aF)();
    const setPopupShown = (0,user_shownPopups/* useSetPopupShown */.aw)();
    const subscriptionBannerWasShownInSession = local_storage/* default */.Z.getSessionItem(constants/* default */.Z.localStorageNames.cartSubscriptionBanner);
    const [courseSubscriptionBannerWasShown, setCourseSubscriptionBannerWasShown] = (0,react.useState)(false);
    const [giftSubscriptionBannerWasShown, setGiftSubscriptionBannerWasShown] = (0,react.useState)(false);
    const offerSubscription = Boolean((subscription === null || subscription === void 0 ? void 0 : subscription.hasNeverSubscribed) && !orderItems.subscription);
    const isSubscriptionBannerEnabled = offerSubscription && (isGiftSubscriptionOfferEnabled ? !orderItems.giftSubscriptionOffer : true);
    const isGiftSubscriptionBannerEnabled = offerSubscription && (isGiftSubscriptionOfferEnabled ? orderItems.giftSubscriptionOffer : false);
    const hasAcademyCourse = orderItems.products.some((product)=>product.type === "AcademyCourse");
    const giftSubscriptionBanner = (0,react.useMemo)(()=>{
        if (!isGiftSubscriptionBannerEnabled || giftSubscriptionBannerWasShown) {
            return null;
        }
        return {
            onCancel: ()=>{
                setGiftSubscriptionBannerWasShown(true);
            }
        };
    }, [
        isGiftSubscriptionBannerEnabled,
        giftSubscriptionBannerWasShown
    ]);
    const subscriptionBanner = (0,react.useMemo)(()=>{
        var _shownPopups_cartSubscriptionBanner;
        if (!isSubscriptionBannerEnabled) {
            return null;
        }
        if (hasAcademyCourse) {
            if (courseSubscriptionBannerWasShown) {
                return null;
            }
            return {
                onCancel: ()=>{
                    setCourseSubscriptionBannerWasShown(true);
                }
            };
        }
        if (subscriptionBannerWasShownInSession) {
            return null;
        }
        const lastUpdated = (_shownPopups_cartSubscriptionBanner = shownPopups["cartSubscriptionBanner"]) === null || _shownPopups_cartSubscriptionBanner === void 0 ? void 0 : _shownPopups_cartSubscriptionBanner.lastUpdated;
        // hide popup for 24 hours
        if (lastUpdated && (0,difference/* getElapsedTime */.q)(lastUpdated, "hours") < 24) {
            return null;
        }
        return {
            onCancel: async ()=>{
                try {
                    if (isLoggedIn) {
                        await setPopupShown("cartSubscriptionBanner");
                    } else {
                        local_storage/* default */.Z.setSessionItem(constants/* default */.Z.localStorageNames.cartSubscriptionBanner, true);
                        setCourseSubscriptionBannerWasShown(true);
                    }
                } catch (error) {
                    (0,errors/* processError */.wY)(error);
                }
            }
        };
    }, [
        isLoggedIn,
        setPopupShown,
        isSubscriptionBannerEnabled,
        hasAcademyCourse,
        subscriptionBannerWasShownInSession,
        shownPopups,
        courseSubscriptionBannerWasShown
    ]);
    return {
        orderItems,
        giftSubscriptionBanner,
        subscriptionBanner,
        hasAcademyCourse
    };
};
/* harmony default export */ const util_useCartItems = (useCartItems);

;// CONCATENATED MODULE: ./src/compositions/modals/CartModal/components/CartItems/CartItems.tsx




const CartItems = (props)=>{
    const { className, cart } = props;
    const { orderItems: { giftCard, giftSubscription, giftSubscriptionOffer, limitedDrops, products, subscription }, subscriptionBanner, giftSubscriptionBanner, hasAcademyCourse } = util_useCartItems(cart);
    let hasFirstItem = false;
    const getClassName = ()=>{
        if (hasFirstItem) {
            return "mt-16";
        }
        hasFirstItem = true;
        return null;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: className,
        children: [
            Boolean(subscription) && /*#__PURE__*/ (0,jsx_runtime.jsx)(SubscriptionOrderItem/* default */.Z, {
                className: getClassName(),
                data: subscription,
                giftSubscriptionOffer: giftSubscriptionOffer,
                withRemoveButton: true
            }),
            Boolean(giftSubscription) && /*#__PURE__*/ (0,jsx_runtime.jsx)(GiftSubscriptionOrderItem/* default */.Z, {
                className: getClassName(),
                data: giftSubscription,
                withRemoveButton: true
            }),
            Boolean(giftCard) && /*#__PURE__*/ (0,jsx_runtime.jsx)(GiftCardOrderItem/* default */.Z, {
                className: getClassName(),
                data: giftCard,
                withRemoveButton: true
            }),
            Boolean(giftSubscriptionOffer) && /*#__PURE__*/ (0,jsx_runtime.jsx)(GiftSubscriptionOfferOrderItem/* default */.Z, {
                className: getClassName(),
                data: giftSubscriptionOffer
            }),
            limitedDrops === null || limitedDrops === void 0 ? void 0 : limitedDrops.map((item)=>{
                const { id } = item;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(orderItems/* LimitedDropOrderItem */.FX, {
                    className: getClassName(),
                    data: item,
                    placement: "cart"
                }, id);
            }),
            products === null || products === void 0 ? void 0 : products.map((item)=>{
                const { drift, id, isRemovable, size } = item;
                const props = {
                    className: getClassName(),
                    data: item,
                    key: `${id}-${size}-${drift === null || drift === void 0 ? void 0 : drift.starterSet}`,
                    withRemoveButton: isRemovable
                };
                if (drift) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(orderItems/* DriftOrderItem */.Wq, {
                        ...props
                    });
                }
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductOrderItem/* default */.Z, {
                    ...props
                });
            }),
            Boolean(subscriptionBanner) && /*#__PURE__*/ (0,jsx_runtime.jsx)(SubscriptionBanner_SubscriptionBanner, {
                className: getClassName(),
                onCancel: subscriptionBanner.onCancel,
                hasAcademyCourse: hasAcademyCourse
            }),
            Boolean(giftSubscriptionBanner) && /*#__PURE__*/ (0,jsx_runtime.jsx)(GiftSubscriptionBanner_GiftSubscriptionBanner, {
                className: getClassName(),
                data: giftSubscriptionOffer,
                onCancel: giftSubscriptionBanner.onCancel
            })
        ]
    });
};
/* harmony default export */ const CartItems_CartItems = (CartItems);

;// CONCATENATED MODULE: ./src/compositions/modals/CartModal/components/CartBill/CartBill.tsx





const CartBill = (props)=>{
    const { className, bill } = props;
    const isStickyCtaEnabled = (0,useAb/* default */.Z)(constants/* default */.Z.abTests.ecomCartStickyCta) === "b";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: className,
        children: bill.map((item, index)=>{
            const { label, note, value, isSubTotal, isTotal, dataTestId } = item;
            if (isStickyCtaEnabled && isTotal) {
                return null;
            }
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderBillItem/* default */.Z, {
                className: index ? "mt-16" : null,
                label: label,
                note: note,
                value: value,
                isLarge: isSubTotal || isTotal,
                "data-testid": dataTestId
            }, index);
        })
    });
};
/* harmony default export */ const CartBill_CartBill = (CartBill);

// EXTERNAL MODULE: ./src/modules/products/useProductGiftPromo.ts + 1 modules
var useProductGiftPromo = __webpack_require__(10066);
// EXTERNAL MODULE: ./src/components/dataDisplay/Progress/Progress.tsx
var Progress = __webpack_require__(12166);
;// CONCATENATED MODULE: ./src/compositions/modals/CartModal/components/GiftWithSpendThresholdProgress/messages.ts
/* harmony default export */ const GiftWithSpendThresholdProgress_messages = ({
    default: {
        remain: {
            en: `
        You\'re <span class="text-gold-50 font-bold">{remain}</span> away from
        <span class="text-gold-50 font-bold">free mystery gift</span>
      `
        },
        earned: {
            en: 'You\'ve earned a <span class="text-gold-50 font-bold">free mystery gift</span>'
        },
        description: {
            en: `
        It’s our 10th anniversary, but you get the presents!
        For a limited time, get a set packed with 5 scent vials
        of surprise 1.5 mL best-sellers on e-commerce purchases of {subTotal} and up.
      `
        }
    },
    fathersDay: {
        remain: {
            en: `
        You\'re <span class="text-gold-50 font-bold">{remain}</span> away from
        <span class="text-gold-50 font-bold">FREE gift!</span>
      `
        },
        earned: {
            en: 'You\'ve earned a <span class="text-gold-50 font-bold">FREE GIFT</span>'
        },
        description: {
            en: `
        Eligible customers will receive a free Confessions of a Rebel GET A ROOM Body Wash
        with any ecommerce purchase of {subTotal} or more.
        While supplies last. Offer applied automatically at checkout.
      `
        }
    }
});

;// CONCATENATED MODULE: ./src/compositions/modals/CartModal/components/GiftWithSpendThresholdProgress/GiftWithSpendThresholdProgress.tsx









const getSpendThresholdMessage = (messagesData, remain)=>{
    if (remain === 0) {
        return messagesData.earned;
    }
    if (remain > 0) {
        return {
            ...messagesData.remain,
            values: {
                remain: (0,formatPrice/* default */.Z)(remain)
            }
        };
    }
    return null;
};
const GiftWithSpendThresholdProgress = (props)=>{
    var _cart_purchaseProgress_ecommercePromoProgress, _cart_purchaseProgress;
    const { className } = props;
    const { cart } = (0,modules_cart/* useCartContext */.iQ)();
    const isHolidayFathersDayEnabled = (0,useFt/* default */.Z)(constants/* default */.Z.features.holidayFathersDay);
    const { subTotal, isFetching } = (0,useProductGiftPromo/* default */.Z)();
    const ecommercePromoProgress = cart === null || cart === void 0 ? void 0 : (_cart_purchaseProgress = cart.purchaseProgress) === null || _cart_purchaseProgress === void 0 ? void 0 : (_cart_purchaseProgress_ecommercePromoProgress = _cart_purchaseProgress.ecommercePromoProgress) === null || _cart_purchaseProgress_ecommercePromoProgress === void 0 ? void 0 : _cart_purchaseProgress_ecommercePromoProgress[0];
    if (!ecommercePromoProgress) {
        return null;
    }
    const { freeEcommercePromoGoal, freeEcommercePromoProgress, freeEcommercePromoRemain } = ecommercePromoProgress;
    const messagesData = isHolidayFathersDayEnabled ? GiftWithSpendThresholdProgress_messages.fathersDay : GiftWithSpendThresholdProgress_messages["default"];
    const message = getSpendThresholdMessage(messagesData, freeEcommercePromoRemain);
    const progress = freeEcommercePromoRemain ? freeEcommercePromoProgress / freeEcommercePromoGoal * 100 : 100;
    if (!message) {
        return null;
    }
    if (isFetching) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Bone/* default */.Z, {
            className: className,
            pw: 100,
            h: 148
        });
    }
    if (!subTotal) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Progress/* default */.Z, {
        className: className,
        message: message,
        progress: progress,
        textStyle: "p2",
        "data-testid": "giftWithSpentThreshold",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
            className: "mb-24 mt-8",
            message: {
                ...messagesData.description,
                values: {
                    subTotal: (0,formatPrice/* default */.Z)(subTotal.amountCents, {
                        removeZeroCents: true
                    })
                }
            },
            style: "p5"
        })
    });
};
/* harmony default export */ const GiftWithSpendThresholdProgress_GiftWithSpendThresholdProgress = (GiftWithSpendThresholdProgress);

;// CONCATENATED MODULE: ./src/compositions/modals/CartModal/components/ShippingStatus/messages.ts
/* harmony default export */ const ShippingStatus_messages = ({
    remain: {
        en: 'Add <b class="text-gold-50">{remain}</b> to your order for <b class="uppercase text-gold-50">Free shipping</b>'
    },
    qualify: {
        en: 'You now qualify for <b class="uppercase text-gold-50">Free shipping</b>'
    }
});

;// CONCATENATED MODULE: ./src/compositions/modals/CartModal/components/ShippingStatus/ShippingStatus.tsx






const ShippingStatus = (props)=>{
    var _cart_shipping, _cart_shipping1;
    const { className, cart } = props;
    // we should use ecommerce item with is the last one
    const shipping = cart === null || cart === void 0 ? void 0 : (_cart_shipping1 = cart.shipping) === null || _cart_shipping1 === void 0 ? void 0 : _cart_shipping1[(cart === null || cart === void 0 ? void 0 : (_cart_shipping = cart.shipping) === null || _cart_shipping === void 0 ? void 0 : _cart_shipping.length) - 1];
    if (!shipping) {
        return null;
    }
    const { freeShippingRemain, price } = shipping;
    let message = null;
    if (freeShippingRemain === 0 && price === 0) {
        // because Canadian users have to paid for subscription shipping, we should check, that shipping is actually free
        message = ShippingStatus_messages.qualify;
    } else if (freeShippingRemain > 0) {
        message = {
            ...ShippingStatus_messages.remain,
            values: {
                remain: (0,formatPrice/* default */.Z)(shipping.freeShippingRemain)
            }
        };
    } else {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
        className: (0,clsx/* default */.Z)(className, "text-center"),
        style: "p4",
        message: message,
        html: true
    });
};
/* harmony default export */ const ShippingStatus_ShippingStatus = (ShippingStatus);

// EXTERNAL MODULE: ./local_modules/intl/Message.tsx + 1 modules
var Message = __webpack_require__(927);
// EXTERNAL MODULE: ./src/components/dataDisplay/Label/Label.tsx + 1 modules
var Label = __webpack_require__(77883);
// EXTERNAL MODULE: ./src/components/inputs/ActionButton/ActionButton.tsx
var ActionButton = __webpack_require__(49952);
;// CONCATENATED MODULE: ./src/compositions/modals/CartModal/components/BundlingBanner/messages.ts
/* harmony default export */ const BundlingBanner_messages = ({
    label: {
        en: "New at Scentbird"
    },
    supTitle: {
        en: "Buy any 4 travel-size fragrances"
    },
    title: {
        en: "Get the 5th free"
    },
    addMore: {
        en: "Add {count, select, 1 {one} 2 {two} 3 {three} 4 {four}} more travel-size {count, plural, one {fragrance} other {fragrances}} to your cart."
    },
    qualify: {
        en: "You qualify for a free fragrance!"
    },
    congrats: {
        en: "Congrats, your reward has been applied to your cart!"
    }
});

;// CONCATENATED MODULE: ./src/compositions/modals/CartModal/components/BundlingBanner/BundlingBanner.tsx












const BundlingBanner = (props)=>{
    const { className } = props;
    const { cart } = (0,modules_cart/* useCartContext */.iQ)();
    const qualifiedProducts = Number(cart === null || cart === void 0 ? void 0 : cart.countByFutureDiscount[constants/* default */.Z.discounts.buy5pay4]);
    const { gender } = (0,user/* useUser */.aF)();
    const link = gender === "FEMALE" ? links/* default */.ZP.shop.travelSize.perfumes : links/* default */.ZP.shop.travelSize.colognes;
    const handleClick = ()=>{
        (0,analytics/* track */.j)("Banner click", {
            content: "Get the 5th free",
            action: "link",
            link,
            placement: "Cart"
        });
    };
    // hide if there is no qualified products in the cart
    if (!qualifiedProducts) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,clsx/* default */.Z)("relative rounded border border-solid border-gray-30 bg-white px-16 pb-16 pt-32", className),
        "data-testid": "bundlingBanner",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Label/* default */.ZP, {
                className: "-left-8 -top-8",
                absolute: true,
                bgColor: "gold-30",
                textColor: "black",
                title: BundlingBanner_messages.label,
                withTail: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                style: "h8",
                message: BundlingBanner_messages.supTitle
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                className: "mt-4",
                style: "h3",
                color: "gold-50",
                message: BundlingBanner_messages.title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.ZP, {
                className: "mt-8 font-bold",
                style: "p4",
                color: "gold-70",
                children: [
                    qualifiedProducts === 4 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Message/* default */.Z, {
                                value: BundlingBanner_messages.qualify
                            }),
                            " "
                        ]
                    }),
                    qualifiedProducts >= 5 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Message/* default */.Z, {
                        value: BundlingBanner_messages.congrats
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Message/* default */.Z, {
                        value: {
                            ...BundlingBanner_messages.addMore,
                            values: {
                                count: 5 - qualifiedProducts
                            }
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-16",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ActionButton/* default */.Z, {
                    style: "black",
                    title: messages/* default */.Z.shopNow,
                    to: link,
                    onClick: handleClick
                })
            })
        ]
    });
};
/* harmony default export */ const BundlingBanner_BundlingBanner = (/*#__PURE__*/(0,react.memo)(BundlingBanner));

;// CONCATENATED MODULE: ./src/compositions/modals/CartModal/messages.ts
/* harmony default export */ const CartModal_messages = ({
    empty: {
        title: {
            en: "Your cart"
        },
        text: {
            en: "Your cart is empty"
        }
    },
    default: {
        title: {
            en: "Your cart total - {total}"
        },
        text: {
            en: "Let’s review your cart..."
        }
    }
});

;// CONCATENATED MODULE: ./src/compositions/modals/CartModal/CartModal.tsx





















const isFullBottle = (volume, unit)=>{
    try {
        const parsedVolume = parseFloat(volume);
        if (unit === "ml") {
            return parsedVolume > 8;
        }
        if (unit === "oz") {
            return parsedVolume > 0.27;
        }
    } catch (error) {}
    return false;
};
const CartModalView = (param)=>{
    let { flow } = param;
    const { isMobile } = (0,useDevice/* default */.Z)();
    const cartContext = (0,modules_cart/* useCart */.jD)();
    const { cart, isFetching } = cartContext;
    const isGwpSpendThresholdEnabled = (0,useFt/* default */.Z)(constants/* default */.Z.features.gwpSpendThreshold);
    const isBuy5Pay4Enabled = (0,esm/* useFeatureIsOn */.cC)(constants/* default */.Z.features.buy5pay4);
    const isStickyCtaEnabled = (0,useAb/* default */.Z)(constants/* default */.Z.abTests.ecomCartStickyCta) === "b";
    const { discounts, shipping, credits, subTotal, total } = cart || {};
    const bill = (0,useOrderBill/* default */.Z)({
        discounts,
        shipping,
        credits,
        subTotal,
        total
    });
    const totalOrderItem = bill.find((item)=>item.isTotal);
    // fire only once after open and fetching
    const isCartDisplayFiredRef = (0,react.useRef)(false);
    const isEmpty = !cart || cart.isEmpty;
    (0,react.useEffect)(()=>{
        if (!cart || isCartDisplayFiredRef.current) {
            return;
        }
        isCartDisplayFiredRef.current = true;
        const productType = new Set();
        // TODO remove later, when we collect data in productType - added on 2023-10-10 by maddoger
        const ecommerceType = new Set();
        if (cart.hasSubscription) {
            productType.add("Perfume subscription");
        }
        if (cart.hasGiftSubscription) {
            productType.add("Gift subscription");
        }
        if (cart.hasGiftCard) {
            productType.add("Gift card");
        }
        if (cart.hasQueueItems) {
            productType.add("Buy queue");
            ecommerceType.add("Buy queue");
        }
        if (cart.hasLimitedDrops) {
            productType.add("Limited drop");
        }
        if (cart.hasProducts) {
            cart.products.forEach((param)=>{
                let { product, offer, price } = param;
                const { volume, unit } = product;
                const typeGroup = product.typeGroup;
                if (offer === "TOSSIN" || offer === "TOSSIN_EMAIL") {
                    productType.add("Toss-in");
                    ecommerceType.add("Toss-in");
                } else if (price === 0) {
                    return;
                } else if (typeGroup === "PerfumeCase" || typeGroup === "FragranceStorageBox") {
                    productType.add("Ecommerce");
                    ecommerceType.add("Extras");
                } else if (typeGroup === "FlashSale") {
                    productType.add("Private sale");
                    ecommerceType.add("Flash sale");
                } else if (typeGroup === "AcademyCourse") {
                    productType.add("Scentbird Academy");
                } else if (typeGroup === "Perfume" && isFullBottle(volume, unit)) {
                    productType.add("Ecommerce");
                    ecommerceType.add("Full-size bottles");
                } else {
                    productType.add("Ecommerce");
                    ecommerceType.add("A la carte");
                }
            });
        }
        (0,analytics/* track */.j)("Cart display", {
            flow,
            productType: Array.from(productType).sort(),
            ecommerceType: Array.from(ecommerceType).sort()
        });
    }, [
        isEmpty,
        flow,
        cart
    ]);
    const title = isEmpty ? CartModal_messages.empty.title : {
        ...CartModal_messages["default"].title,
        values: {
            total: (0,formatPrice/* default */.Z)(cart.total)
        }
    };
    const text = isEmpty ? CartModal_messages.empty.text : null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(modules_cart/* CartContextProvider */.GN, {
        value: cartContext,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalHeadline/* default */.Z, {
                title: title,
                text: text
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex flex-1 flex-col items-stretch justify-start",
                children: !cart ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Bone/* default */.Z, {
                    pw: 100,
                    h: 100
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        !isEmpty && isGwpSpendThresholdEnabled && /*#__PURE__*/ (0,jsx_runtime.jsx)(GiftWithSpendThresholdProgress_GiftWithSpendThresholdProgress, {
                            className: "mb-32"
                        }),
                        !isEmpty && isBuy5Pay4Enabled && /*#__PURE__*/ (0,jsx_runtime.jsx)(BundlingBanner_BundlingBanner, {
                            className: "mb-32"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CartItems_CartItems, {
                            cart: cart
                        }),
                        !isEmpty && /*#__PURE__*/ (0,jsx_runtime.jsx)(CartBill_CartBill, {
                            className: "mt-32",
                            bill: bill
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (0,clsx/* default */.Z)(isStickyCtaEnabled && `sticky bottom-0 mt-24 border-t border-gray-30 bg-white pb-40 ${isMobile ? "-mx-16 -mb-16 px-16" : "-mx-40 -mb-40 px-40"}`),
                children: [
                    isStickyCtaEnabled && totalOrderItem && /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderBillItem/* default */.Z, {
                        className: "mt-16",
                        label: totalOrderItem.label,
                        note: totalOrderItem.note,
                        value: totalOrderItem.value,
                        isLarge: true,
                        "data-testid": totalOrderItem.dataTestId
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalButtons/* default */.Z, {
                        className: isStickyCtaEnabled ? "mt-16" : "",
                        withMargin: !isStickyCtaEnabled,
                        primary: {
                            title: messages/* default */.Z.checkout,
                            to: links/* default */.ZP.checkout,
                            disabled: isEmpty || isFetching,
                            loading: isFetching,
                            fullWidth: true
                        }
                    }),
                    !isEmpty && /*#__PURE__*/ (0,jsx_runtime.jsx)(ShippingStatus_ShippingStatus, {
                        className: "mt-16",
                        cart: cart
                    })
                ]
            })
        ]
    });
};
const FirstProductModalLayer = ()=>{
    const { activeLayers, closeLayer } = (0,ModalWithLayers/* useModalWithLayers */.y)();
    const layerId = "firstProduct";
    const handleClose = (0,react.useCallback)(()=>{
        closeLayer(layerId);
    }, [
        closeLayer,
        layerId
    ]);
    const layerProps = (activeLayers === null || activeLayers === void 0 ? void 0 : activeLayers.get(layerId)) || {};
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalWithLayers/* default */.Z.Layer, {
        id: layerId,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FirstProductModal.FirstProductModalView, {
            ...layerProps,
            closeModal: handleClose
        })
    });
};
const CartModal = (param)=>{
    let { name, flow, closeModal } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalWithLayers/* default */.Z, {
        type: "sidebar-right",
        underMobileHeader: true,
        closeModal: closeModal,
        "data-testid": name,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CartModalView, {
                flow: flow
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FirstProductModalLayer, {})
        ]
    });
};
/* harmony default export */ const CartModal_CartModal = (CartModal);


/***/ }),

/***/ 28914:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  FirstProductModalView: () => (/* binding */ FirstProductModalView),
  "default": () => (/* binding */ FirstProductModal_FirstProductModal)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.push.js
var es_array_push = __webpack_require__(85183);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ../../node_modules/.pnpm/clsx@2.1.0/node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(78364);
// EXTERNAL MODULE: ./local_modules/device/useDevice.ts
var useDevice = __webpack_require__(96934);
// EXTERNAL MODULE: ./local_modules/analytics/index.ts
var analytics = __webpack_require__(95812);
// EXTERNAL MODULE: ./local_modules/local-storage/index.ts + 2 modules
var local_storage = __webpack_require__(71106);
// EXTERNAL MODULE: ./src/helpers/constants/index.ts + 8 modules
var constants = __webpack_require__(63687);
// EXTERNAL MODULE: ./src/modules/user/user/index.tsx + 1 modules
var user = __webpack_require__(40038);
// EXTERNAL MODULE: ./src/modules/products/useCatalogueId.ts + 2 modules
var useCatalogueId = __webpack_require__(91491);
// EXTERNAL MODULE: ./src/modules/products/useCatalogueProducts.ts + 1 modules
var useCatalogueProducts = __webpack_require__(32029);
// EXTERNAL MODULE: ./src/modules/products/useProducts.ts + 1 modules
var useProducts = __webpack_require__(43665);
// EXTERNAL MODULE: ./src/components/feedback/ModalHeadline/ModalHeadline.tsx
var ModalHeadline = __webpack_require__(52690);
// EXTERNAL MODULE: ./src/components/feedback/ModalButtons/ModalButtons.tsx
var ModalButtons = __webpack_require__(99032);
// EXTERNAL MODULE: ./src/components/feedback/PlainModal/PlainModal.tsx + 1 modules
var PlainModal = __webpack_require__(1987);
// EXTERNAL MODULE: ./src/components/inputs/Button/messages.ts
var messages = __webpack_require__(34212);
// EXTERNAL MODULE: ./src/compositions/productCards/ProductCardSmallSkeleton/ProductCardSmallSkeleton.tsx
var ProductCardSmallSkeleton = __webpack_require__(80866);
// EXTERNAL MODULE: ./src/compositions/productCards/ProductCardSmall/ProductCardSmall.tsx
var ProductCardSmall = __webpack_require__(88589);
;// CONCATENATED MODULE: ./src/compositions/modals/FirstProductModal/messages.ts
/* harmony default export */ const FirstProductModal_messages = ({
    title: {
        en: "Want to try something else?"
    },
    text: {
        en: "Add one of our best sellers for your first shipment."
    },
    try: {
        en: "Let’s try this"
    },
    selected: {
        en: "Selected"
    },
    back: {
        en: "Go back"
    }
});

;// CONCATENATED MODULE: ./src/compositions/modals/FirstProductModal/FirstProductModal.tsx















const FirstProductModalView = (props)=>{
    const { selectedTradingItemId, onContinue, closeModal } = props;
    const { isMobile } = (0,useDevice/* default */.Z)();
    const [selectedItem, setSelectedItem] = (0,react.useState)(null);
    const { gender } = (0,user/* useUser */.aF)();
    // TODO use picked items or recommendations in future - added on 2021-10-25 by maddoger
    const { catalogueId, isFetching: isCatalogueFetching } = (0,useCatalogueId/* default */.Z)({
        catalogueName: gender === "FEMALE" ? "perfumes" : "colognes"
    });
    const { data, isFetching: isProductsFetching } = (0,useCatalogueProducts/* default */.Z)({
        variables: {
            id: catalogueId,
            input: {
                filter: [
                    {
                        type: "CATEGORY",
                        filterValueIdList: [
                            "bestsellers"
                        ]
                    }
                ],
                offset: 0,
                limit: 12,
                productsFeed: "BESTSELLERS"
            }
        },
        skip: !catalogueId
    });
    // we use all saved sources of products
    const postponedItems = local_storage/* default */.Z.getItem(constants/* default */.Z.localStorageNames.queuePendingProducts);
    const highPriorityProducts = local_storage/* default */.Z.getItem(constants/* default */.Z.localStorageNames.queueHighPriorityProducts);
    const lowPriorityProducts = local_storage/* default */.Z.getItem(constants/* default */.Z.localStorageNames.queueLowPriorityProducts);
    const postponedProductsIds = [].concat(highPriorityProducts, postponedItems, lowPriorityProducts).filter(Boolean).map((item)=>String(item.product.productId));
    const { products: postponedProducts, isFetching: isPostponedProductsFetching } = (0,useProducts/* default */.Z)({
        variables: {
            input: {
                slugs: postponedProductsIds,
                pagination: {
                    limit: 12
                }
            }
        },
        skip: !(postponedProductsIds === null || postponedProductsIds === void 0 ? void 0 : postponedProductsIds.length)
    });
    const isFetching = isCatalogueFetching || isProductsFetching || !catalogueId || isPostponedProductsFetching;
    const catalogueProducts = data === null || data === void 0 ? void 0 : data.products;
    const products = (0,react.useMemo)(()=>{
        if (isFetching) {
            return null;
        }
        const result = [];
        const ignoreCatalogueProductsIds = [];
        // merge products preferring catalogue ones, because they have more info
        postponedProducts === null || postponedProducts === void 0 ? void 0 : postponedProducts.forEach((item)=>{
            const catalogueProduct = catalogueProducts.find((param)=>{
                let { id } = param;
                return id === item.id;
            });
            if (catalogueProduct) {
                ignoreCatalogueProductsIds.push(item.id);
                result.push(catalogueProduct);
            } else {
                result.push(item);
            }
        });
        catalogueProducts === null || catalogueProducts === void 0 ? void 0 : catalogueProducts.forEach((item)=>{
            if (!ignoreCatalogueProductsIds.includes(item.id)) {
                result.push(item);
            }
        });
        return result.filter((item)=>{
            var _item_tradingItems_items_, _item_tradingItems_items, _item_tradingItems;
            return (item === null || item === void 0 ? void 0 : (_item_tradingItems = item.tradingItems) === null || _item_tradingItems === void 0 ? void 0 : (_item_tradingItems_items = _item_tradingItems.items) === null || _item_tradingItems_items === void 0 ? void 0 : (_item_tradingItems_items_ = _item_tradingItems_items[0]) === null || _item_tradingItems_items_ === void 0 ? void 0 : _item_tradingItems_items_.section) === "Subscription";
        }).slice(0, 12);
    }, [
        isFetching,
        catalogueProducts,
        postponedProducts
    ]);
    const handleContinue = ()=>{
        var _selectedItem_tradingItems_items, _selectedItem_tradingItems;
        const { volume } = (_selectedItem_tradingItems = selectedItem.tradingItems) === null || _selectedItem_tradingItems === void 0 ? void 0 : (_selectedItem_tradingItems_items = _selectedItem_tradingItems.items) === null || _selectedItem_tradingItems_items === void 0 ? void 0 : _selectedItem_tradingItems_items[0];
        (0,analytics/* track */.j)("First product change", {
            productId: selectedItem.id,
            productGender: selectedItem.gender,
            productFullName: selectedItem.fullName,
            productBrand: selectedItem.brandInfo.name,
            productCategory: selectedItem.category,
            productVolume: volume ? `${volume.volume} ${volume.unit}` : undefined
        });
        onContinue(selectedItem);
        closeModal();
    };
    // if selected product is among products, we should pre-select it
    (0,react.useEffect)(()=>{
        if (products) {
            const selectedProduct = products.find((param)=>{
                let { tradingItems } = param;
                var _tradingItems_items;
                return (tradingItems === null || tradingItems === void 0 ? void 0 : (_tradingItems_items = tradingItems.items) === null || _tradingItems_items === void 0 ? void 0 : _tradingItems_items[0].id) === selectedTradingItemId;
            });
            if (selectedProduct) {
                setSelectedItem(selectedProduct);
            }
        }
    }, [
        products,
        selectedTradingItemId
    ]);
    const buttonsClassName = (0,clsx/* default */.Z)("sticky bottom-0 z-floating-header", isMobile ? "-mx-16 -mb-16 mt-32 bg-gold-30 pb-32" : "-mx-40 -mb-40 bg-gray-10 p-40");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalHeadline/* default */.Z, {
                title: FirstProductModal_messages.title,
                text: FirstProductModal_messages.text
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "grid grid-cols-2 gap-16",
                children: isFetching ? new Array(6).fill(null).map((value, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCardSmallSkeleton/* default */.Z, {}, index)) : products === null || products === void 0 ? void 0 : products.map((item)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCardSmall/* default */.Z, {
                        data: item,
                        withoutLink: true,
                        buttonProps: {
                            type: "custom",
                            title: FirstProductModal_messages.try,
                            addedMessage: FirstProductModal_messages.selected,
                            isAdded: selectedItem === item,
                            onClick: ()=>{
                                setSelectedItem(item);
                            }
                        }
                    }, item.id))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalButtons/* default */.Z, {
                className: buttonsClassName,
                primary: {
                    title: messages/* default */.Z.continue,
                    fullWidth: true,
                    disabled: !selectedItem,
                    onClick: handleContinue
                }
            })
        ]
    });
};
const FirstProductModal = (props)=>{
    const { name, closeModal, selectedTradingItemId, onContinue } = props;
    const { isMobile } = (0,useDevice/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PlainModal/* default */.ZP, {
        type: isMobile ? "default" : "sidebar-right",
        closeModal: closeModal,
        "data-testid": name,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FirstProductModalView, {
            selectedTradingItemId: selectedTradingItemId,
            onContinue: onContinue,
            closeModal: closeModal
        })
    });
};
/* harmony default export */ const FirstProductModal_FirstProductModal = (FirstProductModal);


/***/ }),

/***/ 40495:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var helpers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(63687);
/* harmony import */ var hooks__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(64667);


const getCollaboration = (rebrandLabels)=>{
    var _rebrandLabels_extra;
    if (rebrandLabels === null || rebrandLabels === void 0 ? void 0 : (_rebrandLabels_extra = rebrandLabels.extra) === null || _rebrandLabels_extra === void 0 ? void 0 : _rebrandLabels_extra.includes("SAKS_SELECTED")) {
        return "saks";
    }
};
const useProductCollaboration = (param)=>{
    let { labels } = param;
    const isSaksCollaborationEnabled = (0,hooks__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(helpers__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z.features.collaborationSaks);
    const collaboration = getCollaboration(labels);
    if (collaboration === "saks" && isSaksCollaborationEnabled) {
        return collaboration;
    }
    return null;
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useProductCollaboration);


/***/ }),

/***/ 80073:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ collaborations_useProductCollaborationLabel)
});

// EXTERNAL MODULE: ./src/modules/collaborations/useProductCollaboration.ts
var useProductCollaboration = __webpack_require__(40495);
;// CONCATENATED MODULE: ./src/modules/collaborations/messages.ts
/* harmony default export */ const messages = ({
    default: {
        en: "Scentbird Select"
    }
});

;// CONCATENATED MODULE: ./src/modules/collaborations/useProductCollaborationLabel.ts


const useProductCollaborationLabel = (param)=>{
    let { labels } = param;
    const collaboration = (0,useProductCollaboration/* default */.Z)({
        labels
    });
    if (collaboration === "saks") {
        return messages["default"];
    }
};
/* harmony default export */ const collaborations_useProductCollaborationLabel = (useProductCollaborationLabel);


/***/ }),

/***/ 6161:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   z: () => (/* binding */ useCnstrcProductTrackingDataAttrs)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52983);
/* harmony import */ var helpers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23450);


const useCnstrcProductTrackingDataAttrs = (param)=>{
    let { id, name, prices, variationId } = param;
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>{
        const { standardPrice, discountPrice } = prices || {};
        const price = (discountPrice === null || discountPrice === void 0 ? void 0 : discountPrice.amountCents) || (standardPrice === null || standardPrice === void 0 ? void 0 : standardPrice.amountCents);
        const formattedPrice = price && (0,helpers__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(price, {
            withCurrency: false
        });
        return {
            "data-cnstrc-item-id": id,
            "data-cnstrc-item-name": name,
            "data-cnstrc-item-price": formattedPrice,
            "data-cnstrc-item-variation-id": variationId
        };
    }, [
        id,
        name,
        prices,
        variationId
    ]);
};


/***/ }),

/***/ 26676:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ strapi_getRichTextStateFromMessage)
});

// EXTERNAL MODULE: ./local_modules/logger/index.ts
var logger = __webpack_require__(53297);
;// CONCATENATED MODULE: ./src/modules/strapi/isRichTextStateEmpty.ts
const getRichTextStateFromMessage = (richTextState)=>{
    var _richTextState_root_children, _richTextState_root, _richTextState_root_children1, _richTextState_root1;
    return (richTextState === null || richTextState === void 0 ? void 0 : (_richTextState_root = richTextState.root) === null || _richTextState_root === void 0 ? void 0 : (_richTextState_root_children = _richTextState_root.children) === null || _richTextState_root_children === void 0 ? void 0 : _richTextState_root_children.length) === 0 || (richTextState === null || richTextState === void 0 ? void 0 : (_richTextState_root1 = richTextState.root) === null || _richTextState_root1 === void 0 ? void 0 : (_richTextState_root_children1 = _richTextState_root1.children) === null || _richTextState_root_children1 === void 0 ? void 0 : _richTextState_root_children1.some((node)=>{
        var _node_children;
        return (node === null || node === void 0 ? void 0 : (_node_children = node.children) === null || _node_children === void 0 ? void 0 : _node_children.length) !== 0;
    })) === false;
};
/* harmony default export */ const isRichTextStateEmpty = (getRichTextStateFromMessage);

;// CONCATENATED MODULE: ./src/modules/strapi/getRichTextStateFromMessage.ts


const getRichTextStateFromMessage_getRichTextStateFromMessage = (state)=>{
    if (!state) {
        return null;
    }
    try {
        const editorState = JSON.parse(state);
        const isEditorStateEmpty = isRichTextStateEmpty(editorState);
        return !isEditorStateEmpty ? editorState : null;
    } catch (error) {
        logger/* default */.Z.error(error);
        return null;
    }
};
/* harmony default export */ const strapi_getRichTextStateFromMessage = (getRichTextStateFromMessage_getRichTextStateFromMessage);


/***/ })

}]);